import request from "@/core/data/network/client/request";
import Api from "@/core/data/network/constants/api_routes";

export default {
  downloadComplaintEmisoresAnnexes: async (id) => {
    return request.get(Api.downloadComplaintEmisoresAnnexes(id));
  },
  getComplaintEmisorDetail: async (id) => {
    return request.get(Api.getComplaintEmisorDetail(id));
  },
  getComplaintEmisoresList: async (pagination, data) => {
    return request.get(Api.getComplaintEmisoresList(pagination, data));
  },
  generateComplaintEmisoresInfoSolip: async (typeExport, data) => {
    return request.get(
      Api.generateComplaintEmisoresInfoSolip(typeExport, data)
    );
  },   
  retryFilingSolip: async (codigoQueja, data) => {
    return request.post(Api.retryFilingSolip(codigoQueja), data);
  },   
  retryFilingSolipAnexes: async (codigoQueja, idAnexo, data) => {
    return request.post(Api.retryFilingSolipAnexes(codigoQueja, idAnexo), data);
  }   
};
